import React, { Component } from 'react'
class Footer extends Component {
  render() {
    return (
      <footer className='footer'>
        <div className='container-fluid'>
          <div className='d-sm-flex justify-content-end justify-content-sm-end py-2 w-100'>
            <span className='text-muted text-center text-sm-left d-block d-sm-inline-block'>
              Copyright © by EPIS Corp Australia and EPIS VIETNAM CO., LTD
            </span>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
